import React, { useState } from 'react'
import validator from 'validator'
import api from "../../services/api"
import { toast } from 'react-toastify'
import { Link } from "react-router-dom"
import CustomCheckBox from '../../components/CustomCheckBox';
// import styled from 'styled-components'


const Register = (props) => {
    const [errors, setErrors] = useState({})
    const [name, setName] = useState("")
    const [lastname, setLastname] = useState("")
    const [email, setEmail] = useState("")
    const [document, setDocument] = useState("")
    const [password, setPassword] = useState("")
    const [passwordConfirmation, setPasswordConfirmation] = useState("")
    const [terms, setTerms] = useState(false)

    const onSubmit = (e) => {
        let isValid = true;
        let error = {}

        if (!name) {
            error.name = "O campo nome é obrigatório"
            isValid = false;
        } else if (name.length > 70) {
            error.name = "O campo nome possui mais que 70 caractéres"
            isValid = false;
        }
        if (!lastname) {
            error.lastname = "O campo sobrenome é obrigatório"
            isValid = false;
        } else if (lastname.length > 70) {
            error.lastname = "O campo sobrenome possui mais que 70 caractéres"
            isValid = false;
        }
        if (!password) {
            error.password = "O campo senha é obrigatório"
            isValid = false;
        } else if (password.length < 6) {
            error.password = "A senha não contém no mínimo 6 caracteres"
            isValid = false;
        } else if (password !== passwordConfirmation) {
            error.password = "As senhas não são iguais"
            isValid = false
        }
        if (!passwordConfirmation) {
            error.passwordConfirmation = "O campo confirmação de senha é obrigatório"
            isValid = false
        } else if (passwordConfirmation !== password) {
            error.passwordConfirmation = "As senhas não são iguais"
            isValid = false
        }
        if (!email) {
            error.email = "O campo email é obrigatório"
            isValid = false
        } else if (!validator.isEmail(email)) {
            error.mail = "O campo email esta no formato incorreto"
            isValid = false
        }
        if (!document) {
            error.document = "O campo documento é obrigatório"
            isValid = false
        }
        if (!terms) {
            error.terms = "É nescessário aceitar os termos"
            isValid = false
        }
        setErrors(error)
        if (isValid)
            api.post("/student/create", { user: { name, lastname, document, email, password, passwordConfirmation } }).then(res => {
                if (res.success) {
                    toast.success("Usuário registrado com sucesso!");
                    props.history.push("/")
                } else {
                    if (Array.isArray(res.error)) {
                        let error = ''
                        res.error.forEach(e => {
                            error += `O campo ${e.path[0]} está com valores inválidos.\n`
                        })
                        setErrors({ serverSide: error })
                        toast.error("Ops, algo deu errado!");
                    } else {
                        setErrors({ serverSide: res.error })
                        toast.error("Ops, algo deu errado!");
                    }
                }
            }).catch((err) => {
                toast.error("Ops, algo deu errado!");
                console.log(err)
            })
    }

    const pageStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(41, 107, 169, 1)",
        color: "#fff"
    }

    const registerTitle = {
        fontWeight: "bold",
        fontSize: "27px",
        marginBottom: "1em",
        marginTop: "1em"
    }

    const errorsText = {
        textAlign: "center",
        margin: "2em",
        color: "#FF4040"
    }

    const errorsDisplay = {
        textAlign: "center",
        margin: "1em",
        color: "#FF4040"
    }

    const link = <p>Eu li e concordo com os <a href={`${process.env.REACT_APP_HOST}/static/termos_de_uso.pdf`} target="_blank" rel="noopener noreferrer">termos de uso</a> da plataforma</p>
    return (
        <div style={pageStyles}>
            <h1 style={registerTitle}>Cadastro</h1>
            {errors.serverSide && <div style={errorsText}>{errors.serverSide}</div>}
            <div style={{ width: "300px" }}>
                <div className="row" style={{ marginBottom: "1px", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div style={{ backgroundColor: "#ddd", marginBottom: "10px", borderRadius: 15 }}>
                        {errors.name && (<p style={errorsDisplay}> {errors.name} </p>)}
                        {errors.lastname && (<p style={errorsDisplay}> {errors.lastname} </p>)}
                        {errors.email && (<p style={errorsDisplay}> {errors.email} </p>)}
                        {errors.document && (<p style={errorsDisplay}> {errors.document} </p>)}
                        {errors.password && (<p style={errorsDisplay}> {errors.password} </p>)}
                        {errors.terms && (<p style={errorsDisplay}> {errors.terms} </p>)}
                    </div>
                    <div className="col-md-12 mb-3">
                        <input
                            name="name"
                            placeholder="Nome"
                            maxLength={70}
                            error={errors ? errors.name : ''}
                            value={name}
                            onChange={event => setName(event.target.value)}
                            className="form-control"
                        />
                    </div>

                    <div className="col-md-12 mb-3">
                        <input
                            name="lastname"
                            placeholder="Sobrenome"
                            maxLength={70}
                            error={errors ? errors.lastname : ''}
                            value={lastname}
                            onChange={event => setLastname(event.target.value)}
                            className="form-control"
                        />
                    </div>

                    <div className="col-md-12 mb-3">
                        <input
                            name="mail"
                            type="email"
                            error={errors ? errors.email : ''}
                            value={email}
                            onChange={event => setEmail(event.target.value)}
                            className="form-control"
                            aria-describedby="emailHelp"
                            placeholder="E-mail"
                        />
                    </div>

                    <div className="col-md-12 mb-3">
                        <input
                            name="document"
                            placeholder="CPF (Somente números)"
                            error={errors ? errors.document : ''}
                            value={document}
                            onChange={event => {
                                const re = /^[0-9\b]+$/;
                                if (event.target.value === '' || re.test(event.target.value))
                                    setDocument(event.target.value)
                            }}
                            className="form-control"
                        />
                    </div>

                    <div className="col-md-12 mb-3">
                        <input
                            type="password"
                            value={password}
                            error={errors ? errors.password : ''}
                            onChange={event => setPassword(event.target.value)}
                            className="form-control"
                            placeholder="Senha (no mínimo 6 caracteres)"
                        />
                    </div>

                    <div className="col-md-12">
                        <input
                            type="password"
                            value={passwordConfirmation}
                            error={errors ? errors.passwordConfirmation : ''}
                            onChange={event => setPasswordConfirmation(event.target.value)}
                            className="form-control"
                            placeholder="Confirmar senha"
                        />
                    </div>
                    <div className="col-md-12 mt-2">
                        <CustomCheckBox
                            label={link}
                            checked={terms}
                            onChange={() => setTerms(!terms)}
                        />
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-12">
                        <button
                            className="large-btn"
                            onClick={event => onSubmit(event)}
                        >
                            Cadastrar
                        </button>
                    </div>
                </div>
                <Link to="/" style={{ color: '#fff' }}>Já possuo uma conta</Link>
            </div>
        </div>
    )


};

export default Register;